import { combineSlices } from '@reduxjs/toolkit'
import clientApi from 'api/clientApi'
import IntegrationApi from 'api/integrationApi'
import ruleApi from 'api/ruleApi'
import thresholdsApi from 'api/thresholdsApi'

const rootReducer = combineSlices(
  clientApi,
  IntegrationApi,
  ruleApi,
  thresholdsApi
)

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
